module.exports = __webpack_public_path__ + "img/d03-min.84ac1e59.png";